export default __webpack_public_path__ + "static/media/landing-image-mobile.cedfade2.jpg";